import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom'
import Header from '../core/header';
import Footer from '../core/footer';
import RoutesData from '../../models/routesdata';
import RoutesComponent from '../../components/routes/routescomponent';

class Layout extends Component {
  render() {
    let routesdata = RoutesData;
    return (
      <div className="pb-layout">
        <Header/>
        <div className="container-fluid pb-app-container">
          <Routes>
            {
              routesdata.map((item, index) => {
                return <Route key={index} path={item.route} Component={() => <RoutesComponent page={item.route} />} />
              })
            }
          </Routes>
        </div>
        <Footer/>
      </div>
    );
  } 
}

export default Layout;
